// extracted by mini-css-extract-plugin
export var indeterminate = "_1s-5";
export var md = "_1s-4";
export var semantic = "_1s-6";
export var sm = "_1s-3";
export var text = "_1s-7";
export var toggleInput = "_1s-0";
export var toggleSwitch = "_1s-1";
export var xs = "_1s-2";